import type {
  AdminStructureDamGeometry,
  AdminStructureDamHydrology,
  AdminStructureDetail,
  AdminStructureOpenPitGeometry,
  AdminStructureStockpileGeometry,
  AdminStructureStockpileHydrology,
  StructureType,
} from "../api/structures/structures.types";
import type { AdminStructureOpenPitGeometryForm } from "./structures-geometry-hydrology.schema";

const emptyGeometryDefaults = {
  dam: {
    crestElevation: "",
    damHeight: "",
    crestLength: "",
    crestWidth: "",
    typicalBermWidth: "",
    upstreamSlopeInclination: "",
    downstreamSlopeInclination: "",
    betweenBermsSlopeInclination: "",
    globalDownstreamSlopeInclination: "",
    referenceDocument: "",
  } satisfies AdminStructureDamGeometry,
  stockpile: {
    typicalBermWidth: "",
    benchSlopeInclination: "",
    globalSlopeInclination: "",
    referenceDocument: "",
  } satisfies AdminStructureStockpileGeometry,
  openPit: {
    sectors: "",
    pitHeight: "",
    typicalBermWidth: "",
    benchHeight: "",
    benchInclination: "",
    globalSlopeInclination: "",
    referenceDocument: "",
  } satisfies AdminStructureOpenPitGeometryForm,
};

const emptyHydrologyDefaults = {
  dam: {
    maximumMaximorumLevel: "",
    criticalDuration: "",
    inflowRate: "",
    outflowRate: "",
    designRainfall: "",
    contributingBasinArea: "",
    returnPeriod: "",
    totalVolumeAtCrestElevation: "",
    spillwayType: "surface" as const,
    spillwaySill: "",
    referenceDocument: "",
  } satisfies AdminStructureDamHydrology,
  stockpile: {
    criticalDuration: "",
    outflowRate: "",
    designRainfall: "",
    returnPeriod: "",
    referenceDocument: "",
  } satisfies AdminStructureStockpileHydrology,
};

export const mapDetailToOpenPitGeometryForm = (
  detail: AdminStructureDetail,
): AdminStructureOpenPitGeometryForm => {
  const defaults = emptyGeometryDefaults.openPit;
  if (!detail.geometry || !("sectors" in detail.geometry)) {
    return defaults;
  }
  const geometry = detail.geometry as AdminStructureOpenPitGeometry;
  return {
    ...defaults,
    ...geometry,
    sectors: geometry.sectors,
  };
};

export const mapDetailToGeometryForm = (
  detail: AdminStructureDetail,
  structureType: StructureType,
) => {
  if (structureType === "openPit") {
    return mapDetailToOpenPitGeometryForm(detail);
  }
  const defaults = emptyGeometryDefaults[structureType];
  if (!detail.geometry) {
    return defaults;
  }
  return { ...defaults, ...detail.geometry };
};

export const mapDetailToHydrologyForm = (
  detail: AdminStructureDetail,
  structureType: StructureType,
) => {
  if (structureType === "openPit") {
    return null;
  }
  const defaults = emptyHydrologyDefaults[structureType];
  if (!detail.hydrology) {
    return defaults;
  }
  return { ...defaults, ...detail.hydrology };
};
